import { AttendanceSystem } from "../AttendanceSystem";
import { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const EmployeeAttendance = ({ employeeId, attendanceRecords = new Map() }) => {
  const attendanceSystem = new AttendanceSystem();
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    // Initialize with provided attendance records
    attendanceSystem.attendanceRecords = new Map(attendanceRecords);
    attendanceSystem.initializeEmployees([{ id: employeeId, name: 'Employee Name' }]);

    // Calculate stats for week, month, and year
    const weeklyStats = attendanceSystem.getAttendanceStats(employeeId, 'week');
    const monthlyStats = attendanceSystem.getAttendanceStats(employeeId, 'month');
    const yearlyStats = attendanceSystem.getAttendanceStats(employeeId, 'year');

    // Prepare data for pie chart (using monthly stats as an example)
    const ctx = chartRef.current?.getContext('2d');
    if (ctx) {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
      chartInstance.current = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: ['Present', 'Absent'],
          datasets: [{
            data: [monthlyStats.present, monthlyStats.absent],
            backgroundColor: ['#36A2EB', '#FF6384'],
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: 'top' },
            title: { display: true, text: 'Monthly Attendance' },
          },
        },
      });
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [attendanceSystem, employeeId, attendanceRecords]);

  const weeklyStats = attendanceSystem.getAttendanceStats(employeeId, 'week');
  const monthlyStats = attendanceSystem.getAttendanceStats(employeeId, 'month');
  const yearlyStats = attendanceSystem.getAttendanceStats(employeeId, 'year');

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg">
    
      
      {/* Pie Chart */}
      <div className="h-64 mb-6">
        <canvas ref={chartRef}></canvas>
      </div>

      {/* Attendance Stats Table */}
      <table className="w-full text-sm md:text-base mb-6">
        <thead className="bg-gray-100">
          <tr>
            <th className="py-2 px-4 text-left">Period</th>
            <th className="py-2 px-4 text-left">Present</th>
            <th className="py-2 px-4 text-left">Absent</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-t">
            <td className="py-2 px-4">This Week</td>
            <td className="py-2 px-4">{weeklyStats.present} days</td>
            <td className="py-2 px-4">{weeklyStats.absent} days</td>
          </tr>
          <tr className="border-t">
            <td className="py-2 px-4">This Month</td>
            <td className="py-2 px-4">{monthlyStats.present} days</td>
            <td className="py-2 px-4">{monthlyStats.absent} days</td>
          </tr>
          <tr className="border-t">
            <td className="py-2 px-4">This Year</td>
            <td className="py-2 px-4">{yearlyStats.present} days</td>
            <td className="py-2 px-4">{yearlyStats.absent} days</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default EmployeeAttendance;